"use strict";
const _ = require('lodash');
const ensureZipCodeToOfcMaps = entity => {
    if (!entity.zipCodeToOfcMaps) {
        return [];
    }
    // Remove spaces from zip codes
    const cleanedZipCodeToOfcMaps = entity.zipCodeToOfcMaps.map(zipCodeToOfcMap => {
        if (_.isEmpty(zipCodeToOfcMap.zipCodeStart) ||
            _.isEmpty(zipCodeToOfcMap.zipCodeEnd)) {
            return zipCodeToOfcMap;
        }
        return {
            ...zipCodeToOfcMap,
            zipCodeStart: zipCodeToOfcMap.zipCodeStart
                .replace(/\s/g, '')
                .padEnd(5, '0'),
            zipCodeEnd: zipCodeToOfcMap.zipCodeEnd
                .replace(/\s/g, '')
                .padEnd(5, '9'),
        };
    });
    // Check for overlapping ranges
    const zipCodeRanges = cleanedZipCodeToOfcMaps.map(map => ({
        start: parseInt(map.zipCodeStart, 10),
        end: parseInt(map.zipCodeEnd, 10),
    }));
    const sortedZipCodeRanges = zipCodeRanges.sort((a, b) => a.start - b.start);
    for (let i = 0; i < sortedZipCodeRanges.length - 1; i++) {
        if (sortedZipCodeRanges[i].end >= sortedZipCodeRanges[i + 1].start) {
            throw new Error('Zip code ranges overlap');
        }
    }
    return cleanedZipCodeToOfcMaps;
};
module.exports = entity => {
    const ensuredZipCodeToOfcMaps = ensureZipCodeToOfcMaps(entity);
    return {
        ...entity,
        zipCodeToOfcMaps: ensuredZipCodeToOfcMaps,
    };
};
